import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    components: {
      default: HomeView
    },
    children: [
      {
        path: '',
        name: 'DashboardItem',
        components: {
          dashboard: () => import('../views/DashboardItem.vue')
        }
      },
      {
        path: '/currencies',
        name: 'CurrenciesItem',
        components: {
          dashboard: () => import('../views/CurrenciesView.vue')
        }
      },
      {
        path: '/exchange-rate',
        name: 'ExchangeRateItem',
        components: {
          dashboard: () => import('../views/ExchangeRate.vue')
        }
      },
      {
        path: '/transactions',
        name: 'TransactionsItem',
        components: {
          dashboard: () => import('../views/TransactionView.vue')
        }
      },
      {
        path: '/transactions/new',
        name: 'NewTransactionItem',
        components: {
          dashboard: () => import('../views/TransactionForm.vue')
        }
      },
      {
        path: '/transactions/edit/:id',
        name: 'EditTransactionItem',
        components: {
          dashboard: () => import('../views/TransactionForm.vue')
        }
      },
      {
        path: '/reports',
        name: 'ReportsItem',
        components: {
          dashboard: () => import('../views/ReportsView.vue')
        }
      },
      {
        path: '/clients',
        name: 'ClientsItem',
        components: {
          dashboard: () => import('../views/ClientsView.vue')
        }
      }
    ]
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/auth-sign-in',
    name: 'auth-sign-in',
    component: () => import('../views/LoginView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
